var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 131 141"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3.93,
    d: "M18.821 106.011c-11.39 0-15.863-7.666-16.763-11.767A2.713 2.713 0 0 1 2 93.66V66.332c0-.634.188-1.254.54-1.781l2.993-4.49c.258-.388.426-.813.503-1.272C9.305 39.419 25.816 2 67.042 2c41.16 0 55.682 37.299 57.948 56.695.06.52.237 1.005.527 1.44l2.944 4.416c.351.527.539 1.147.539 1.781V93.66c0 .197-.015.391-.062.583-1.004 4.1-7.69 11.768-15.357 11.768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3.93,
    d: "M18.54 56.669c3.552-13.737 18.504-41.212 47.66-41.212 29.157 0 42.988 27.475 47.941 41.212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.428,
    height: 63.92,
    x: 94.517,
    y: 47.978,
    fill: "#fff",
    rx: 8.565
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.428,
    height: 63.92,
    x: 94.517,
    y: 47.978,
    fill: "#fff",
    rx: 8.565
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.428,
    height: 63.92,
    x: 15.457,
    y: 47.978,
    fill: "#fff",
    rx: 8.565
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 22.428,
    height: 63.92,
    x: 15.457,
    y: 47.978,
    fill: "#fff",
    rx: 8.565
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3.93,
    d: "M114.702 106.011c-.374 5.42-6.673 18.671-28.877 28.315"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 28.035,
    height: 15.7,
    x: 61.435,
    y: 124.795,
    fill: "#1AC876",
    rx: 7.85
  })));
};
export default SvgHeadset;